
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../constants/constants";
import { getDossierSubjects } from "../../store/actions/rating";
import { finalAndMoreRatingsColors } from "../../constants/checkup";
import { Select } from "antd";
import LoaderSimple from "../general/loader";
const { Option } = Select;

const RatingPage = () => {

  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);

  const companies = useSelector(state => state.rating?.companyRatingList?.list);
  const isGettingCompanies = useSelector(state => state.rating?.isGettingRatingCompanies);

  const [filters, setFilters] = useState({name: "",
    piva: "",
    fiscalCode: "",
    finalRatings: []});
  const [companiesFilter, setCompaniesFilter] = useState([]);

  useEffect(() => {
    dispatch(getDossierSubjects(auth, main.accountantUuidSelected));
  },[]);

  useEffect(() => {
    setCompaniesFilter(companies);
  },[companies]);

  useEffect(() => {
    if (filters.name === "" && filters.piva === "" && filters.fiscalCode === "" && filters.finalRatings.length === 0){
      setCompaniesFilter(companies);
    } else {
      if ((filters.finalRatings.length > 0)){
        setCompaniesFilter(companies.filter(company => ((company.name).toLowerCase()).indexOf((filters.name).toLowerCase()) > -1
                                                    && ((company.piva).toLowerCase()).indexOf((filters.piva).toLowerCase()) > -1
                                                    && ((company.fiscalCode).toLowerCase()).indexOf((filters.fiscalCode).toLowerCase()) > -1
                                                    && ((filters.finalRatings).indexOf(company.approvedAnalysis?.finalRating) > -1 )));
      } else {
        setCompaniesFilter(companies.filter(company => ((company.name).toLowerCase()).indexOf((filters.name).toLowerCase()) > -1
                                                    && ((company.piva).toLowerCase()).indexOf((filters.piva).toLowerCase()) > -1
                                                    && ((company.fiscalCode).toLowerCase()).indexOf((filters.fiscalCode).toLowerCase()) > -1));
      }
    }

  },[filters]);

  const getIcon = (rating) => {
    return (<div style= {{height: "16px",
      width: "16px",
      backgroundColor: getFinalAndMoreRatingColor(rating),
      borderRadius: "50%",
      marginRight: "18px",
      border: "1px solid #d8d8d9",
      display: "inline-block",
      verticalAlign: "text-bottom"}}
    ></div>);
  };

  const getFinalAndMoreRatingColor = (finalRating) => {
    return finalAndMoreRatingsColors[finalRating];
  };

  return (<div>
    <table style={{backgroundColor: "white", width:"98%", margin:"20px"}} >
      <tr style={{color: "#005075"}}>
        <th style={{width:"30%"}}>{"Nome azienda"}</th>
        <th style={{width:"20%"}} >{"Partita Iva"}</th>
        <th style={{width:"20%"}}>{"Codice Fiscale"}</th>
        <th style={{width:"15%"}}>{"Rating"}</th>
        <th style={{width:"15%"}}>{"Ultima analisi"}</th>
      </tr>
      <tr style={{backgroundColor:"#f2f5f8"}}>
        <td>
          <Input
            onChange={e => setFilters({...filters, name: e})}
            id={"id"}
            placeholder={"Cerca"}
            autoComplete="off"
            suffix={<FontAwesomeIcon
              icon={["far", "search"]}
              style={{color: "#0090d1", fontSize: "16px", cursor: "pointer" }}
            />}
          />
        </td>
        <td>
          <Input
            onChange={e => setFilters({...filters, piva: e})}
            id={"vatNumber"}
            placeholder={"Cerca"}
            autoComplete="off"
            suffix={<FontAwesomeIcon
              icon={["far", "search"]}
              style={{ color: "#0090d1", fontSize: "16px", cursor: "pointer" }}
            />}
          />
        </td>
        <td>
          <Input
            onChange={e => setFilters({...filters, fiscalCode: e})}
            id={"taxId"}
            placeholder={"Cerca"}
            autoComplete="off"
            suffix={<FontAwesomeIcon
              icon={["far", "search"]}
              style={{ color: "#0090d1", fontSize: "16px", cursor: "pointer" }}
            />}
          />
        </td>
        <td>
          <Select
            style={{width:"250px", marginTop: "-4px"}}
            placeholder={"Seleziona"}
            onChange={e => setFilters({...filters, finalRatings: e})}
            mode="multiple">
            <Option value="A"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>A</div><div>{getIcon("A")}</div></div></Option>
            <Option value="AA"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>AA</div><div>{getIcon("AA")}</div></div></Option>
            <Option value="AAA"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>AAA</div><div>{getIcon("AAA")}</div></div></Option>
            <Option value="B"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>B</div><div>{getIcon("B")}</div></div></Option>
            <Option value="BB"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>BB</div><div>{getIcon("BB")}</div></div></Option>
            <Option value="BBB"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>BBB</div><div>{getIcon("BBB")}</div></div></Option>
            <Option value="C"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>C</div><div>{getIcon("C")}</div></div></Option>
            <Option value="CC"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>CC</div><div>{getIcon("CC")}</div></div></Option>
            <Option value="CCC"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>CCC</div><div>{getIcon("CCC")}</div></div></Option>
            <Option value="D"><div style={{display:"flex", width: "30%", justifyContent: "space-between"}}><div>D</div><div>{getIcon("D")}</div></div></Option>
          </Select>
        </td>
        <td></td>
      </tr>
      {!isGettingCompanies && companiesFilter ?
        companiesFilter.map((company, key) => (
          <tr style={{height: "48px", borderBottom:"0.5px solid #9da6ad"}} key={key}>
            <td>
              {company.name
                ? company.name
                : "--"}
            </td>
            <td>
              {company.piva
                ? company.piva
                : "--"}
            </td>
            <td>
              {company.fiscalCode
                ? company.fiscalCode
                : "--"}
            </td>
            <td>
              {company.approvedAnalysis
                ?.finalRating ? (
                  <div style={{display:"flex", width: "25%", justifyContent: "space-between"}}>
                    <div>
                      {
                        company
                          .approvedAnalysis
                          ?.finalRating
                      }
                    </div>
                    {getIcon(company.approvedAnalysis?.finalRating)}

                  </div>
                ) : (
                  "--"
                )}
            </td>
            <td>
              {company.approvedAnalysis
                ?.createdAt ? (
                  <div>{moment(company.approvedAnalysis?.createdAt).format(DATE_FORMAT_FOR_DISPLAY)}</div>

                ) : (
                  "--"
                )}
            </td>
          </tr>
        )) :
        (<tr><td colSpan='5'><LoaderSimple message="Caricamento dati in corso..." /></td></tr>)}
    </table>
  </div>);
};

export default RatingPage;